import * as React from "react";
import {isLoggedIn} from "../../Functions/Authentication";
import IFrame from "../IFrame/IFrame";
import {getCurrentPageURL} from "../../Functions/CurrentPage";

class Comments extends React.Component {
  onLocationChange(location) {
    if (location.pathname !== "/forum/sso" && location.pathname !== "/forum/entry/jsconnect" && location.pathname !== "/forum/discussion/embed/") {
      window.location.href = location.href;
    }
  }

  render() {
    let src = "/discussion/embed/?vanilla_identifier=" + encodeURIComponent(this.props.id) + "&vanilla_category_id=10&vanilla_title="+ encodeURIComponent(this.props.title) + "&vanilla_url=" + encodeURIComponent(getCurrentPageURL());

    if (isLoggedIn()) {
      src = "/forum/sso?Target=" + encodeURIComponent(src);
    } else {
      src = "/forum" + src;
    }

    return (
        <IFrame autoHeight={true} className={this.props.className} src={src} onLocationChange={this.onLocationChange.bind(this)}/>
    );
  }
}

export default Comments;
